import MonthlyPaymentModal from "../montly-payment-modal";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import Text from "shared/ui/typography/Text";
import Icon, { IconTypes } from "shared/ui/icon";
import { concatClassnames } from "shared/utils/concatClassnames";
import { memo, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";

interface Props {
  monthlyPayment: number | undefined;
  className?: string;
  showInfoButton?: boolean;
}

const MonthlyPayment = ({
  monthlyPayment,
  className = "",
  showInfoButton = true,
}: Props) => {
  const [isMonthlyPaymentModalOpened, setIsMonthlyPaymentModalOpened] =
    useState(false);

  const formattedMonthlyPayment = useMemo(
    () => getFormattedPrice(monthlyPayment),
    [monthlyPayment]
  );

  return (
    <div>
      <div className="gg-flex gg-flex-row gg-w-full  gg-gap-x-1.5 gg-mt-1 gg-items-center">
        <Text
          className={twMerge(
            "gg-self-end gg-text-xs lg:gg-text-sm xl:gg-text-xs",
            className
          )}
        >
          of v.a.{" "}
          {monthlyPayment !== null &&
            monthlyPayment !== 0 &&
            formattedMonthlyPayment}{" "}
          per maand
        </Text>

        {showInfoButton && (
          <button
            className=" gg-ml-1 gg-rounded-xl gg-bg-yellow"
            onClick={() =>
              setIsMonthlyPaymentModalOpened(!isMonthlyPaymentModalOpened)
            }
          >
            <Icon name={IconTypes.INFO} className="gg-h-4" />
          </button>
        )}
      </div>

      <MonthlyPaymentModal
        isOpen={isMonthlyPaymentModalOpened}
        setIsOpen={setIsMonthlyPaymentModalOpened}
      />
    </div>
  );
};

export default memo(MonthlyPayment);
